const promotion = {
  page: {
    opening: "Opening Promotion Center",
    loading: "Verifying your session and loading campaign data.",
    notice: "Notice",
    errors: {
      settings: "Unable to load curator settings.",
      initialize: "Unable to initialize Promotion Center.",
    },
  },
  center: {
    campaignWorkspace: "Campaign Workspace",
    aiStudio: "AI Promotion Studio",
  },
  common: {
    refresh: "Refresh",
    optional: "optional",
    unknown: "Unknown",
    unknownType: "unknown type",
    unknownBot: "Unknown bot",
    unknownChannel: "unknown",
    bot: "Bot:",
    roles: { superAdmin: "Super-Admin", admin: "Admin" },
    created: "Created {{date}}",
    createdBy: "Created {{date}} by {{username}}",
    startedCompleted: "Started {{started}} · Completed {{completed}}",
    checked: "Checked {{date}}",
    total: "{{count}} total",
    viewAll: "View all",
    cancel: "Cancel",
    delete: "Delete",
    enable: "Enable",
    disable: "Disable",
    add: "Add",
    status: {
      draft: "Draft",
      ready: "Ready",
      running: "Running",
      completed: "Completed",
      partial: "Partial",
      failed: "Failed",
      cancelled: "Cancelled",
    },
    contentMode: {
      original: "Original",
      teaser: "Teaser",
      ai: "AI prepared",
      custom: "Custom",
    },
    deliveryStatus: {
      pending: "Pending",
      in_progress: "In progress",
      success: "Success",
      failed: "Failed",
      skipped: "Skipped",
    },
    chatType: {
      channel: "Channel",
      group: "Group",
      supergroup: "Supergroup",
    },
  },
  workspace: {
    loadingTitle: "Loading Promotion Center",
    loadingDescription: "Campaigns, targets, and delivery history are being synchronized.",
    heroEyebrow: "Promotion Center",
    heroTitle: "Campaign distribution workspace",
    heroDescription: "Turn collected posts into controlled promotion campaigns, deliver to verified Telegram channels and groups, and retry only failed destinations.",
    loadErrorTitle: "Promotion data could not be loaded",
    tabs: {
      overview: "Overview",
      campaigns: "Campaigns",
      create: "Create Campaign",
      targets: "Promotion Targets",
      history: "Delivery History",
    },
    stats: {
      campaigns: "Campaigns",
      active: "Active",
      completed: "Completed",
      attention: "Need attention",
    },
    recent: {
      title: "Recent campaigns",
      description: "Latest promotion activity and campaign state.",
      emptyTitle: "No campaigns yet",
      emptyDescription: "Create the first promotion campaign from collected Telegram posts.",
      create: "Create campaign",
    },
    readiness: {
      title: "Target readiness",
      summary: "targets verified and available for campaign launch",
      ready: "Ready",
      blocked: "Blocked",
      empty: "No promotion targets configured yet.",
      review: "Review targets →",
    },
    create: {
      title: "Create promotion campaign",
      description: "Create the campaign shell first. You will select posts, prepare copy, choose targets, and launch from the campaign workspace.",
      name: "Campaign name",
      namePlaceholder: "e.g. Weekly technology roundup",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Internal campaign notes, objective, audience…",
      draftNote: "Campaigns begin as Draft. No Telegram messages are sent until you explicitly select verified targets and confirm launch.",
      action: "Create Campaign",
    },
    campaigns: {
      title: "Campaigns",
      empty: "No campaigns yet.",
      selectTitle: "Select a campaign",
      selectDescription: "Open a campaign from the list to compose and publish it.",
      markReady: "Mark Ready",
      backDraft: "Back to Draft",
      deleteAria: "Delete campaign {{name}}",
      deliveries: "Deliveries",
      succeeded: "Succeeded",
      failed: "Failed",
      warnings: "Warnings",
    },
    posts: {
      addTitle: "Add collected post",
      searchPlaceholder: "Search collected posts by channel, ID, or text…",
      select: "Select a collected post ({{count}} shown)",
      aiNote: "AI mode uses prepared copy from AI Promotion Studio or manually entered copy.",
      contentMode: "Content mode",
      promotionText: "Promotion text",
      aiPlaceholder: "Enter prepared AI promotion copy here.",
      textPlaceholder: "Write the promotional version of this post…",
      cta: "Call to action",
      ctaPlaceholder: "Read more / Join the channel…",
      sourceLink: "Source link override",
      save: "Save copy",
      originalTitle: "Original collected post",
      sourceUnavailable: "Source post unavailable.",
      preview: "Telegram preview",
      copyNotReady: "Promotion copy is not ready yet.",
      emptyTitle: "Campaign has no posts",
      emptyDescription: "Add one or more collected posts before selecting promotion targets.",
      editAria: "Edit campaign post",
      removeAria: "Remove campaign post",
    },
    launch: {
      title: "Select promotion targets",
      description: "Only verified, enabled targets can be selected. A failed target will not block successful destinations.",
      verified: "Verified",
      noTargets: "No promotion targets exist yet. A Super Admin must configure and verify at least one target before a campaign can launch.",
      running: "This campaign is already running. Resume uses the original target set stored by the backend.",
      selected_one: "{{formattedCount}} target selected",
      selected_other: "{{formattedCount}} targets selected",
      posts_one: "{{formattedCount}} campaign post",
      posts_other: "{{formattedCount}} campaign posts",
      deliveries: "up to {{count}} deliveries",
      confirmHint: "Press again to confirm publishing",
      confirm: "Confirm Launch",
      launch: "Launch Campaign",
    },
    delivery: {
      title: "Delivery report",
      description: "Per-target result and retry audit trail.",
      retrySelected: "Retry selected ({{count}})",
      retryAll: "Retry all failed",
      headers: {
        status: "Status",
        post: "Post",
        target: "Target",
        attempts: "Attempts",
        result: "Result",
      },
      lastAttempt: "Last {{date}}",
      success: "Published successfully",
    },
    targets: {
      addTitle: "Add campaign destination",
      addDescription: "Add the Telegram channel or group that campaigns may publish to. A connection test is required before the destination becomes selectable.",
      name: "Destination name",
      namePlaceholder: "Partner News Channel",
      chatId: "Telegram chat ID / @username",
      chatIdPlaceholder: "@channel or -100…",
      chatType: "Chat type",
      publishingBot: "Publishing bot",
      selectBot: "Select bot account",
      disabledSuffix: "disabled",
      credentialMissingSuffix: "credential missing",
      botHelp: "The bot must already be a member/admin of the destination with permission to post.",
      add: "Add destination",
      registerHelp: "Save your personal bot token in Destinations, then register that bot for your private campaign workspace.",
      register: "Register my Destination Bot",
      listTitle: "Campaign destinations",
      listDescription: "These channels and groups are the destination pool shown when launching a campaign.",
      summary: "{{verified}} verified · {{total}} total",
      ready: "Ready for campaigns",
      needsVerification: "Needs verification",
      connectionError: "Connection error",
      disabled: "Disabled",
      typeNotVerified: "type not verified",
      retest: "Re-test",
      test: "Test connection",
      emptyTitle: "No campaign destinations configured",
      emptyDescription: "Add one of your Telegram channels or groups above, then test its connection.",
    },
    history: {
      title: "Delivery history",
      description: "Completed, partial, and failed campaigns are retained as an audit trail. Open a campaign to inspect individual delivery attempts.",
      emptyTitle: "No delivery history yet",
      emptyDescription: "Campaign results will appear here after the first launch.",
    },
    feedback: {
      refreshed: "Promotion workspace refreshed.",
      loadFailed: "Unable to load promotion data.",
      campaignLoadFailed: "Unable to load campaign.",
      nameRequired: "Campaign name is required.",
      created: "Promotion campaign created.",
      createFailed: "Unable to create campaign.",
      marked: "Campaign marked {{status}}.",
      updateFailed: "Unable to update campaign.",
      deleteConfirm: "Delete draft campaign “{{name}}”?",
      deleted: "Campaign deleted.",
      deleteFailed: "Unable to delete campaign.",
      choosePost: "Choose a collected post first.",
      postAdded: "Post added to promotion campaign.",
      attachFailed: "Unable to attach post.",
      modeNeedsText: "{{mode}} mode requires promotion text before launch.",
      copySaved: "Promotion copy saved.",
      copySaveFailed: "Unable to update promotion copy.",
      removePostConfirm: "Remove this post from the campaign?",
      postRemoved: "Post removed from campaign.",
      removePostFailed: "Unable to remove campaign post.",
      botRegistered: "Your saved Destination Bot is now available for personal campaigns.",
      botRegisterFailed: "Unable to register your Destination Bot for campaigns.",
      targetRequired: "Target name, Telegram chat ID, and bot account are required.",
      targetCreated: "Promotion destination created. Test the connection before campaign use.",
      targetCreateFailed: "Unable to create promotion destination.",
      targetVerified: "Promotion destination verified and ready for campaigns.",
      targetVerificationFailed: "Promotion destination verification failed.",
      targetEnabled: "Promotion destination enabled.",
      targetDisabled: "Promotion destination disabled.",
      targetUpdateFailed: "Unable to update promotion destination.",
      targetDeleteConfirm: "Delete promotion destination “{{name}}”? Existing delivery history will prevent deletion when required for audit.",
      targetDeleted: "Promotion destination deleted.",
      targetDeleteFailed: "Unable to delete promotion destination.",
      selectTarget: "Select at least one verified promotion target.",
      delivered: "Promotion campaign delivered successfully.",
      deliveryResults: "Campaign finished with delivery results. Review the report below.",
      launchFailed: "Unable to launch promotion campaign.",
      selectFailed: "Select failed deliveries to retry.",
      retryFinished: "Retry finished. Delivery report updated.",
      retryFailed: "Unable to retry failed deliveries.",
      sessionChanged: "Session changed. Please reopen your workspace.",
      requestFailed: "Promotion request failed ({{status}}).",
    },
  },
  ai: {
    loading: "Loading Promotion AI Studio",
    heroEyebrow: "AI Promotion Engine",
    heroTitle: "Generate, review, then save",
    heroDescription: "Generate promotion-specific copy with the configured Gemini or OpenRouter model. Results stay editable and are never published automatically.",
    operationFailed: "AI operation failed",
    campaignPost: "Campaign post",
    campaign: "Campaign",
    selectCampaign: "Select campaign",
    post: "Post",
    selectPost: "Select campaign post",
    campaignState: "{{status}} campaign · {{editing}} · role {{role}}",
    editingEnabled: "AI editing enabled",
    readOnly: "read-only after publishing starts",
    generationControls: "Generation controls",
    action: "AI action",
    writingStyle: "Writing style",
    outputLanguage: "Output language",
    outputLanguagePlaceholder: "English",
    extraInstructions: "Extra instructions",
    instructionsPlaceholder: "Audience, emphasis, length preference…",
    generate: "Generate {{action}}",
    backendNote: "Provider and API keys are resolved on the backend from the existing AI configuration. Source text is treated as untrusted material, not model instructions.",
    generatedTitle: "Generated result",
    generatedDescription: "Review before applying it to campaign copy.",
    generatedPlaceholder: "AI output will appear here…",
    apply: "Apply result to editor",
    editorTitle: "Campaign copy editor",
    editorDescription: "This is what will be saved for later Telegram publishing.",
    contentMode: "Content mode",
    promotionText: "Promotion text",
    cta: "Call to action",
    ctaPlaceholder: "Read more / Join the channel…",
    save: "Save to campaign",
    preview: "Telegram preview",
    previewEmpty: "Select a campaign post to preview the final promotion copy.",
    styles: {
      professional: "Professional",
      news: "News",
      educational: "Educational",
      friendly: "Friendly",
      casual: "Casual",
      marketing: "Marketing",
      viral: "Viral",
    },
    actions: {
      teaser: { label: "Teaser", help: "Create a concise curiosity-building introduction without clickbait." },
      rewrite: { label: "Promotional rewrite", help: "Turn the source or current draft into polished promotional copy." },
      shorten: { label: "Shorten", help: "Compress the working copy while preserving essential facts." },
      expand: { label: "Expand", help: "Improve structure and explanation without inventing new facts." },
      translate: { label: "Translate", help: "Translate faithfully while preserving links, names, and formatting." },
      cta: { label: "Generate CTA", help: "Generate one short call-to-action for the campaign post." },
      hashtags: { label: "Generate hashtags", help: "Create 3–6 relevant Telegram hashtags." },
    },
    feedback: {
      selectPost: "Select a campaign post first.",
      editableOnly: "AI generation is available only for Draft or Ready campaigns.",
      chooseLanguage: "Choose a target language for translation.",
      generated: "{{action}} generated. Review it before applying.",
      generationFailed: "AI generation failed.",
      applied: "Generated result applied to the editable campaign copy.",
      editOnly: "Only Draft or Ready campaign posts can be edited.",
      modeNeedsText: "{{mode}} mode requires promotion text.",
      saved: "AI-assisted promotion copy saved to the campaign.",
      saveFailed: "Unable to save promotion copy.",
      loadFailed: "Unable to load Promotion AI Studio.",
      campaignLoadFailed: "Unable to load campaign.",
      sessionChanged: "Session changed. Please reopen your workspace.",
      requestFailed: "Promotion AI request failed ({{status}}).",
    },
  },
} as const;

export default promotion;
